import { Component, Input, OnInit } from '@angular/core';
import { Icon, IconFormat } from '../../../models/record';

@Component({
  selector: 'opac-record-cover',
  templateUrl: './record-cover.component.html',
  styleUrls: ['./record-cover.component.scss'],
})
export class RecordCoverComponent implements OnInit {
  readonly listCoverCount = Array(3).fill(0);
  readonly IconFormat = IconFormat;

  /**
   * Sets main cover url
   */
  @Input() coverUrl?: string;
  /**
   * Determines cover icon if set
   */
  @Input() icon?: Icon;
  /**
   * Adds fake covers to simulate list stack
   */
  @Input() isList: boolean = false;
  /**
   * Check if record type icon should be visible
   */
  @Input() showIcon: boolean = true;

  resolvedIcon?: Icon;

  ngOnInit() {
    this.resolvedIcon = this.icon;

    if (this.isList) {
      this.resolvedIcon = {
        icon: IconFormat.FORMAT_LIST,
        label: 'common.viewMode.list',
      };
    }
  }
}
